import { useMutation } from "@apollo/client";

import { AddBeneficiaryMutation, AddBeneficiaryMutationVariables } from "@ctypes";
import { ADD_BENEFICIARY, USER } from "@graphql";

export const useAddBeneficiary = () => {
  return useMutation<AddBeneficiaryMutation, AddBeneficiaryMutationVariables>(ADD_BENEFICIARY, {
    refetchQueries: [{ query: USER }],
    awaitRefetchQueries: true,
  });
};
